export default (function (v) { return v; });
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/identity.js
// module id = null
// module chunks = 